import { useState, useEffect } from "react";
import { PieChart, Pie, Legend, Cell, ResponsiveContainer } from "recharts";
import { getAccountStatusesCountAsync } from "../../../services/dashboardService";

const colors = [
  "#60a5fa",
  "#c5b5fd",
  "#d1d5db",
  "#34d399",
  "#fde78a",
  "#fca5a5",
];

const AccountStatus = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      setIsLoading(true);

      const { result } = await getAccountStatusesCountAsync();

      if (mounted) {
        const items = result.map((item) => {
          item["name"] = item.status_type;

          return item;
        });

        setData(items);
        setIsLoading(false);
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  const renderLegend = (props) => {
    const { payload } = props;

    return (
      <div className="text-xs">
        {payload.map((entry, index) => {
          return (
            <div key={`item-${index}`} className="flex items-center mt-1">
              <div
                className="h-3 w-3"
                style={{ backgroundColor: colors[index] }}
              ></div>
              <p className="text-gray-400 ml-2">{entry.value}</p>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="card p-0">
      <div className="flex justify-between p-6">
        <p className="text-gray-500">Account Status</p>
      </div>
      {isLoading && (
        <div className="flex justify-center items-center space-x-1 h-64">
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
          <div className="bg-blue-400 w-2 h-2 full rounded-full animate-bounce blue-circle"></div>
        </div>
      )}
      {!isLoading && (
        <ResponsiveContainer width="100%" height={250}>
          <PieChart width={180} height={100}>
            <Pie
              data={data}
              dataKey="total_count"
              cx="70%"
              cy="90%"
              isAnimationActive={false}
              innerRadius={70}
              outerRadius={80}
              fill="#82ca9d"
              label
            >
              {data.map((entry, index) => (
                <Cell key={index} fill={colors[index]} />
              ))}
            </Pie>
            <Legend
              wrapperStyle={{ top: 0, left: 25 }}
              content={renderLegend}
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default AccountStatus;
